import React, { useEffect, useReducer, useRef, useState } from 'react'
import Modal from '../../../../../Modal/Modal';
import { useDispatch, useSelector } from 'react-redux';
import styles from "../Aibox/AiboxForm.module.css"
import Input from '../../../../../CustomDropDown/Input/Input';
import Button1 from '../../../../Button/Button1';
import { addAibox, addCamectAPI, addHikvision, addSigfoxAPI, aiboxLogin, hikvisionLogin, updateCamectAPI } from '../../../../../../Api Methods/Api';
import { checkAuthLoader } from '../../../../../../auth';
import Button2 from '../../../../Button/Button2';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import Lottie from 'lottie-react';
import loadingAnim from '../../../../../../assets/animations/pleasewait.json'
import fail from '../../../../../../assets/animations/fail.json'
import success from '../../../../../../assets/animations/success.json'

import check from '../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/check.png'
import cross from '../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/cross.png'

const TextReducer = (state, action) => {

    if (action.type === 'USER_INPUT') {
        return { value: action.val, isValid: action.val.length > 0 };
    }

    if (action.type === 'INPUT_BLUR') {
        return { value: state.value, isValid: state.value.length > 0 };
    }

    if (action.type === 'INPUT_CLEAR') {
        return { value: action.val, isValid: null };
    }

    return { value: '', isValid: false };
}

const HikvisionForm = ({ setShowVirtualSource, outputs, fetchVirtualSources }) => {

    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const DeviceUUID = useSelector(state => state.auth.DeviceUUID);
    const apiData = {
        token,
        client
    }
    const [modalComponent, setModalComponent] = useState(null);
    const [modalPageIndex, setModalPageIndex] = useState(0);
    const [pinSelected, setPinSelected] = useState(null)
    const ModalDialog = useRef();
    const [message, setMessage] = useState("")
    const [invalidIP, setInvalidIP] = useState("")
    const [linkMessage, setLinkMessage] = useState("Attempting to Hikvision, please wait...")
    const [linkTitle, setLinkTitle] = useState("Logged in successfully!")
    const [loading, setLoading] = useState(false)

    const userID = useSelector(state => state.auth.userID);

    const [failReason, setFailReason] = useState("")

    const [availableEvents, setAvailableEvents] = useState([])
    const [selectedEvents, setSelectedEvents] = useState([])

    const [title, setTitle] = useState("Link Hikvision")

    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();
        HandelResetModal();
    }

    const handleEventSelected = (event) => {
        console.log(event)
        setSelectedEvents((prevSelectedEvents) => {
            if (prevSelectedEvents.includes(event)) {
                return prevSelectedEvents.filter(
                    (selectedEvent) => selectedEvent !== event
                );
            } else {
                return [...prevSelectedEvents, event];
            }
        });
    };

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                HandelResetModal();
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
      
    const [ipAddressState, dispatchIPAddressState] = useReducer(TextReducer, {
        value: '',
        isValid: null
    });

    const [portState, dispatchPortState] = useReducer(TextReducer, {
        value: '',
        isValid: null
    });

    const [usernameState, dispatchUsernameState] = useReducer(TextReducer, {
        value: '',
        isValid: null
    });

    const [passwordState, dispatchPasswordState] = useReducer(TextReducer, {
        value: '',
        isValid: null
    });

    const ipAddressRef = useRef();
    const portRef = useRef();
    const usernameRef = useRef();
    const passwordRef = useRef();

    function validateIPAddress(value) {
        if (value == ''){
            return null
        }

        if (/^https?:\/\//i.test(value)) {
            return "Do not include http:// or https://";
        }

        if (/:\d+$/.test(value)) {
            return "Do not include port number in this field";
        }

        // if (!ipRegex.test(value)) {
        //     return "Invalid IP address format";
        // }

        return "";
    }

    const ipAddressChangeHandler = (e) => {
        const value = e.target.value;
        const errorMessage = validateIPAddress(value);

        dispatchIPAddressState({ type: "USER_INPUT", val: value });
        setInvalidIP(errorMessage);
    };


    const portChangeHandler = (event) => {
        dispatchPortState({ type: 'USER_INPUT', val: event.target.value });
    }

    const usernameChangeHandler = (event) => {
        dispatchUsernameState({ type: 'USER_INPUT', val: event.target.value });
    }

    const passwordChangeHandler = (event) => {
        dispatchPasswordState({ type: 'USER_INPUT', val: event.target.value });
    }

    const HandelResetModal = () => {
        setModalPageIndex(null);
        setShowVirtualSource(null);
    }

    const dispatch = useDispatch();

    const submitHandler = async (event) => {
        event.preventDefault();
    };

    const HandlePinSelected = (pin) => {
        setPinSelected(pin);
        setModalPageIndex(1);
    }

    useEffect(() => {
        if (availableEvents.length > 0){
            setModalPageIndex(10)
        }
    }, [availableEvents])

    const HandleLogin = async () => {
        setMessage("")
        setModalPageIndex(3)
        let loginBody = {
            "protocol": "http",
            "hostName": ipAddressState.value,
            "port": portState.value,
            "username": usernameState.value,
            "password": passwordState.value,
            "userID": userID
        }

        const controller = new AbortController()
        const timeoutId = setTimeout(() => controller.abort(), 15_000)

        try {
            const loginResponse = await hikvisionLogin(
                apiData,
                loginBody,
                dispatch,
                controller.signal
            )

            if (loginResponse.success) {
                setAvailableEvents(loginResponse.data)
            } else {
                setModalPageIndex(11)
                setFailReason("Failed to login to Hikvision, please check your credentials & try again")
            }
        } catch (err) {
            setModalPageIndex(11)
            if (err.name === "AbortError") {
                setFailReason("Login timed out. Please check your login credentials and try again.")
            } else {
                setFailReason("An unexpected error occurred. Please try again.")
            }
        } finally {
            clearTimeout(timeoutId)
        }
    }


    const HandleLink = async () => {
        const fullIP = `${ipAddressState.value}:${portState.value}`
        const body = {
            pinNumber: pinSelected,
            siteUUID: DeviceUUID,
            userID: userID,
            ipAndPort: fullIP,
            eventsToHandle: selectedEvents
        }

        const response = await addHikvision(apiData, body, dispatch)
        if (response.success){
            //HandleCloseModal();
            setModalPageIndex(8)
        } else {
            //HandleCloseModal();
            setModalPageIndex(11);
            setFailReason("Failed to link Hikvision, please try again")
        }
    }


    useEffect(() => {
        switch (modalPageIndex) {
            case 0:
                setTitle("Link Hikvision")
                setModalComponent(
                    <form onSubmit={submitHandler} className={styles["container1"]} method="dialog">
                        <h3 style={{color:"#6e6e6e"}}>Which output would you like to link the Hikvision to?</h3>
                        <br></br>
                        <small style={{color:"#6e6e6e"}}>Please make sure the Hikvision and your selected output are set to the same state.</small>                        
                        <small style={{color:"#6e6e6e"}}>If they are different, the first command will only be used to sync them and</small>
                        <small style={{color:"#6e6e6e"}}>will NOT change the Hikivision.</small>
                        <br></br>
                        <br></br>
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "15px" }}>
                            
                            <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", gap: "20px", width: "100%" }}>
                                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", gap: "20px", width: "100%" }}>
                                    <ul style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "center", gap: "10px" }}>
                                    {outputs.map((output) => {
                                            return (
                                                <li key={output.Pin}>
                                                    <Button2 style={{minWidth:"350px", minHeight:"50px"}}type={"button"} onClick={() => HandlePinSelected(output.Pin)}>
                                                        {output.pinName}
                                                    </Button2>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </form>
                )
                HandleShowModal();
                break;
            case 1:
                setModalComponent(
                    <div className={`${styles.container}`}>
                        <div className={`${styles.card}`}>
                            {message && <p className={styles.errorMessage}>{message}</p>}
                            <h2 style={{color:"#6e6e6e"}}>Hikvision Login</h2>
                            <p style={{color:"#6e6e6e"}}>Login to your account by completing the fields below</p>

                            <br></br>
                            <small style={{color:"#6e6e6e"}}>Please do not include 'https://' or port in the IP Address</small>
                            <br></br>
                            {invalidIP && <small className={styles.errorMessage}>{invalidIP}</small>}

                            <input
                                placeholder={"IP Address"}
                                ref={ipAddressRef}
                                id="ipAddress"
                                value={ipAddressState.value}
                                onChange={ipAddressChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />

                            <input
                                placeholder={"Port"}
                                ref={portRef}
                                id="port"
                                value={portState.value}
                                onChange={portChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />
                            <input
                                placeholder={"Username"}
                                ref={usernameRef}
                                id="username"
                                value={usernameState.value}
                                onChange={usernameChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />
                            <input
                                placeholder={"Password"}
                                ref={passwordRef}
                                id="password"
                                value={passwordState.value}
                                onChange={passwordChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />

                            <br></br>

                            <Button severity="info" type="submit" disabled={loading} onClick={HandleLogin}>
                                {loading ? "Logging in..." : "Log in"}
                            </Button>
                        </div>
                    </div>    
                   
                )
                HandleShowModal();
                break;
            case 2: 
                setModalComponent(
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                        <h3 style={{color:"#6e6e6eff"}}>{linkTitle}</h3>
                        <br></br>
                        <p style={{color:"#6e6e6eff"}}>{linkMessage}</p>
                        <br></br>
                        <Button severity="info" type="submit" disabled={loading} onClick={HandleCloseModal}>
                                {"Close"}
                        </Button>
                    </div>
                )
                HandleShowModal();
                break; 
            case 3: 
            setModalComponent(
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <h3 style={{color:"#6e6e6eff"}}>Logging in...</h3>
                    <br></br>
                    <p style={{color:"#6e6e6eff", margin:"10px"}}>Please wait, logging into Hikvision</p>
                    <Lottie
                        animationData={loadingAnim}
                        loop={true}
                        style={{ width: 450, height: 450, margin: "0px" }}
                    />
                </div>
            )

            HandleShowModal();
            break;
        case 8:
            //success
            setModalComponent(
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                   
                    <div>
                        <h3 style={{ textAlign: "center", color: "#858585" }}>Hikvision linked successfully!</h3>
                    </div>

                    <br></br>
                     <Lottie
                        animationData={success}
                        loop={false}
                        style={{ width: 250, height: 250, margin: "0px" }}
                    />
                    
                    <div>
                        <br></br>
                        <Button 
                            onClick={() => {HandleCloseModal(); fetchVirtualSources();}} 
                            style={{ width: "100%" }}
                            severity='secondary'
                            label='Close'
                        />
                    </div>
                </div>
            )
            HandleShowModal();
        break;
        case 9:
            //fail 
            setModalComponent(
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                  <img className={styles.ModalIcon} src={cross}>
                  </img>
                  <br></br>
                  <br></br>
                  <div>
                    <h3 style={{ textAlign: "center", color: "#858585" }}>Failed to link Hikvision</h3>
                    <h3 style={{ textAlign: "center", color: "#858585" }}>{failReason}</h3>
                  </div>
                  <br></br>
                  <br></br>
                  <div>
                    <br></br>
                    <Button1 onClick={HandleCloseModal} style={{ width: "100%" }}>Close</Button1>
                  </div>
                </div>
              )
            
            HandleShowModal();
        break; 
        case 10:
            setModalComponent(
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <h3 style={{color:"#6e6e6eff"}}>Select the events to control below</h3>
                    <br/>
                    {availableEvents.length > 0 &&
                        availableEvents.map((event, index) => (
                            <Button
                                key={index}
                                severity="secondary"
                                outlined={!selectedEvents.includes(event)}
                                label={event.eventType}  
                                style={{ marginBottom: "10px", width: "200px" }}
                                onClick={() => handleEventSelected(event)}
                            />
                        ))
                    }
                    <br/>

                    <Button
                        label={"Link Hikvision"} 
                        severity="success" 
                        disabled={selectedEvents.length == 0}
                        style={{ marginBottom: "10px", width: "200px" }}
                        onClick={() => HandleLink()}
                    />
                </div>
            )
        break;
        
        case 11: 
            setModalComponent(
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <h3 style={{color:"#6e6e6eff"}}>Failed to login</h3>
                    <br/>
                    <Lottie
                        animationData={fail}
                        loop={false}
                        style={{ width: 150, height: 150, margin: "0px" }}
                    />

                    <br></br>
                    <p style={{color:"#6e6e6eff", margin:"10px"}}>{failReason}</p>
                    <br/>
                    <Button label='Close' severity='secondary' onClick={HandleCloseModal}/>
                </div>
            )

            HandleShowModal();
            break;
        }
    }, [modalPageIndex, ipAddressState, portState, usernameState, passwordState, linkMessage, linkTitle, message, failReason, selectedEvents]);

    return (
        <>
            <Modal ref={ModalDialog} title={title} HandleShowModal={HandleShowModal} HandleCloseModal={HandleCloseModal} modalLayoutStyle={{ alignItems: "center" }}>
                {modalComponent}
            </Modal>
        </>
    )
}

export default HikvisionForm;